<router-outlet></router-outlet>
<ej-base></ej-base>
<a id="btnNavigate"></a>
<ej-session-timeout></ej-session-timeout>
<ej-intercom></ej-intercom>